var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaingoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.0703,
    r: 12,
    fill: "#0D3470",
    stroke: "#0D3470",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.049 5.99739C12.349 5.07639 13.652 5.07639 13.951 5.99739L15.021 9.28939C15.0863 9.48988 15.2134 9.66457 15.384 9.7885C15.5547 9.91242 15.7601 9.97924 15.971 9.97939H19.433C20.402 9.97939 20.804 11.2194 20.021 11.7894L17.221 13.8234C17.05 13.9474 16.9227 14.1224 16.8573 14.3232C16.7919 14.5241 16.7918 14.7405 16.857 14.9414L17.927 18.2334C18.227 19.1544 17.172 19.9214 16.387 19.3514L13.587 17.3174C13.4162 17.1934 13.2105 17.1266 12.9995 17.1266C12.7884 17.1266 12.5828 17.1934 12.412 17.3174L9.61197 19.3514C8.82797 19.9214 7.77397 19.1544 8.07297 18.2334L9.14297 14.9414C9.20815 14.7405 9.20803 14.5241 9.14264 14.3232C9.07725 14.1224 8.94994 13.9474 8.77897 13.8234L5.97997 11.7904C5.19697 11.2204 5.59997 9.98039 6.56797 9.98039H10.029C10.24 9.98045 10.4457 9.91373 10.6165 9.78979C10.7873 9.66585 10.9145 9.49104 10.98 9.29039L12.05 5.99839L12.049 5.99739Z",
    fill: "#FDFBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaingoal);
export default __webpack_public_path__ + "static/media/maingoal.eccf9a0b9f30a78731c892e47c9ab493.svg";
export { ForwardRef as ReactComponent };